import API from "@/js/api/api";

export default new API("/api/extractions");
